import React from 'react';
import { Alert, Box, Button, CircularProgress, Container } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useSalonAccess } from '../../../context/SalonAccessContext';
import SalonThemeEditor from '../../common/salonTheme/SalonThemeEditor';
import { firstPermittedProfessionalRoute } from '../access/SalonPermissionGate';


const SalonThemeSettingsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { salonId } = useParams();
  const numericSalonId = Number(salonId);
  const {
    salons,
    hasPermission,
    canSee,
    isLoading,
    isError,
  } = useSalonAccess();

  if (isLoading) {
    return <Box sx={{ display: 'grid', placeItems: 'center', py: 8 }}><CircularProgress /></Box>;
  }
  if (isError) {
    return <Alert severity="error">{t('pro_manager_access.load_error')}</Alert>;
  }
  if (!hasPermission(numericSalonId, 'salon.manage_theme')) {
    return <Navigate to={firstPermittedProfessionalRoute(canSee)} replace />;
  }

  const salon = salons.find(
    (candidate) => Number(candidate.salon_id) === numericSalonId,
  );
  if (!salon) {
    return <Navigate to="/pro/salon" replace />;
  }

  return (
    <Container
      data-testid="salon-theme-settings-container"
      data-full-width="true"
      maxWidth={false}
      disableGutters
      sx={{
        py: 3,
        px: 0,
        '@media (min-width: 804px) and (max-width: 819.95px)': {
          width: 'calc(100% + 16px)',
          ml: '-8px',
        },
      }}
    >
      <Box
        data-testid="salon-theme-back-row"
        sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}
      >
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/pro/salon')}
        >
          {t('pro_dashboard.salon.back')}
        </Button>
      </Box>
      <SalonThemeEditor
        salonId={numericSalonId}
        salonName={salon.localized_name || salon.name}
      />
    </Container>
  );
};

export default SalonThemeSettingsPage;
